const BEFORE_ACTIVE_TAB_CHANGE_EVENT = 'ipb:before-active-tab-change';

interface ActiveTabChangeDetail {
  from?: string;
  to: string;
}

export function notifyBeforeActiveTabChange(from: string | undefined, to: string): void {
  if (!from || from === to) return;

  window.dispatchEvent(
    new CustomEvent<ActiveTabChangeDetail>(BEFORE_ACTIVE_TAB_CHANGE_EVENT, {
      detail: { from, to },
    })
  );
}

export function subscribeToTabDeactivation(tabKey: string, onDeactivate: () => void): () => void {
  const handleBeforeTabChange = (event: Event) => {
    const { from } = (event as CustomEvent<ActiveTabChangeDetail>).detail;
    if (from === tabKey) onDeactivate();
  };

  window.addEventListener(BEFORE_ACTIVE_TAB_CHANGE_EVENT, handleBeforeTabChange);
  return () => window.removeEventListener(BEFORE_ACTIVE_TAB_CHANGE_EVENT, handleBeforeTabChange);
}
